export const BASIC_MENU_ITEM_TYPE = 'BasicMenuItem'
export const CUSTOM_MENU_TYPE = 'CustomMenu'
export const BUILDER_MENU_ITEM_TYPE = 'Builder.MenuItem'
export const BUILDER_MENU_TYPE = 'Builder.MenuItems'
